import CollectionHeaderPopup from "./collection-header-popup";

export default CollectionHeaderPopup;